// extracted by css-extract-rspack-plugin
export default {"icon-nav":"buttonStyles-icon-nav_vUl","cls2":"buttonStyles-cls2_v8p buttonStyles-cls1_zK9","cls1":"buttonStyles-cls1_zK9"};